
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-search-line',
      title: 'Product Sourcing',
      description: 'Connect with verified suppliers and manufacturers worldwide for quality products at competitive prices.',
    },
    {
      icon: 'ri-tools-line',
      title: 'Product Development',
      description: 'From concept to market-ready products with our experienced development and design team.',
    },
    {
      icon: 'ri-truck-line',
      title: 'Supply Chain Management',
      description: 'Streamlined logistics and supply chain optimization for efficient global operations.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Quality Control',
      description: 'Rigorous inspection and quality assurance processes to ensure product excellence.',
    },
    {
      icon: 'ri-global-line',
      title: 'Global Logistics',
      description: 'Comprehensive shipping and logistics solutions for worldwide distribution.',
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Consulting Services',
      description: 'Expert guidance on market entry, compliance, and business strategy optimization.',
    },
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Comprehensive Global Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From sourcing to delivery, we provide end-to-end solutions for your business needs
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-600">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
